export default __webpack_public_path__ + "static/media/mobile2.b90ef556.png";